var _path, _path2, _path3, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMetric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9156_13282)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9156_13282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9156_13282)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9156_13282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9156_13282)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9156_13282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9156_13282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.3726 18.6274 0 12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24Z",
    fill: "url(#paint0_linear_9156_13282)"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5H6.5C5.675 5 5 5.675 5 6.5V17.5C5 18.325 5.675 19 6.5 19H17.5C18.325 19 19 18.325 19 17.5V6.5C19 5.675 18.325 5 17.5 5ZM9 16C9 16.275 8.775 16.5 8.5 16.5H8C7.725 16.5 7.5 16.275 7.5 16V13.25C7.5 12.975 7.725 12.75 8 12.75H8.5C8.775 12.75 9 12.975 9 13.25V16ZM11.5 16C11.5 16.275 11.275 16.5 11 16.5H10.5C10.225 16.5 10 16.275 10 16V9.5C10 9.225 10.225 9 10.5 9H11C11.275 9 11.5 9.225 11.5 9.5V16ZM14 16C14 16.275 13.775 16.5 13.5 16.5H13C12.725 16.5 12.5 16.275 12.5 16V8C12.5 7.725 12.725 7.5 13 7.5H13.5C13.775 7.5 14 7.725 14 8V16ZM16.5 16C16.5 16.275 16.275 16.5 16 16.5H15.5C15.225 16.5 15 16.275 15 16V11.25C15 10.975 15.225 10.75 15.5 10.75H16C16.275 10.75 16.5 10.975 16.5 11.25V16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9156_13282",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9156_13282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMetric);
export default __webpack_public_path__ + "static/media/add-metric.6ed486c8274ea504ba93f499d92223f9.svg";
export { ForwardRef as ReactComponent };